var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer_badge_left",style:({ opacity: _vm.discountPercentage(_vm.product) ? 1 : 0 })},[_c('span',[_vm._v("On Sale "+_vm._s(_vm.discountPercentage(_vm.product))+" OFF")])])
}
var staticRenderFns = []

export { render, staticRenderFns }